/*
 * @Author: Teemo Ding
 * @Date: 2021-09-06 14:28:43
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 11:05:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/BasicInformation/index.tsx
 */
import { Checkbox, Input, Label, Tag, TextArea } from '@/src/components/Antd';
import { validPromoCode } from '@/src/request/salesChannel/discounts';
import { NEW } from '@/src/tools/constant';
import { replaceI18nVariables } from '@/src/tools/tools';
import { Form } from 'antd';
import { get, uniq } from 'lodash';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { ItemWrapper, RangePicker } from 'src/components/';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import { getParameter } from '@/src/tools/helper';

interface IParams {
  uuid: string;
  discountUuid: string;
}

const BasicInformationComponents = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    activeTime,
    setActiveTime,
    activeTimeError,
    setActiveTimeError,
    form,
    setHasModified,
    scTimezoneUTC,
    isPrimary,
    disableEdit,
  } = props;
  const params = useParams<IParams>();
  const { uuid: salesChannelUuid, discountUuid } = params;
  const regBreak = new RegExp(/[,｜\s｜，|,]+/g);
  // const regSpace = new RegExp(/[,｜\s｜，|,]|[^\a-\z\A-\Z0-9\\-]+/g);
  const regCodeCheck = new RegExp(/^[0-9a-zA-Z-|,｜\s｜，|,]{1,}$/);
  const [isVerifying, setIsVerifying] = React.useState(false);
  const duplicated = getParameter('duplicate');

  const activeTimeOnchange = (value) => {
    if (setHasModified) setHasModified(true);
    setActiveTimeError(false);
    setActiveTime(value);
  };

  /**
   * 处理promoCodes
   * @param value
   */

  const codeInputBreak = (value) => {
    setIsVerifying(true);
    const codesMap = form.getFieldValue('codes') || [];
    const substringArray = value.split(regBreak);
    const validArr = uniq(
      substringArray.filter(
        (i) => !regBreak.test(i) && !codesMap.includes(i) && i !== '',
      ),
    );

    const reqArr = [];
    validArr.forEach((code) => {
      const requestData = {
        salesChannelUuid,
        discountUuid: discountUuid === NEW || !!duplicated ? '' : discountUuid,
        discountCode: code,
      };
      reqArr.push(validPromoCode(requestData));
    });

    if (reqArr.length > 0) {
      const validCodes = [];
      const invalidCodes = [];
      Promise.all(reqArr).then((res) => {
        validArr.forEach((code, index) => {
          const isValid = res[index];
          if (isValid) {
            validCodes.push(code);
          } else {
            invalidCodes.push(code);
          }
        });
        const newCodes = [...codesMap, ...validCodes];
        form.setFields([{ name: 'codes', value: newCodes }]);
        if (invalidCodes.length > 0) {
          form.setFields([
            {
              name: 'promoCode',
              errors: [getI18n('general.codeNotExist')],
              value: invalidCodes.join(','),
            },
          ]);
        } else {
          form.setFields([
            {
              name: 'promoCode',
              errors: [],
              value: '',
            },
          ]);
        }
        setIsVerifying(false);
      });
    } else {
      setIsVerifying(false);
    }
  };

  const inputOnChange = (value) => {
    const reg = new RegExp(/^[A-Z0-9a-z,\\-]+$/);
    if (regBreak.test(value) && regCodeCheck.test(value)) {
      codeInputBreak(value.toUpperCase());

      if (setHasModified) setHasModified(true);
    } else if (reg.test(value) || !value) {
      form.setFieldsValue({ promoCode: value.toUpperCase() });
    }
  };

  const pressEnter = (e) => {
    //用户点击回车事件
    const { value } = e.target;
    if (regCodeCheck.test(value)) {
      codeInputBreak(value.toUpperCase());
    }
    // codeInputBreak(value.toUpperCase());
    // if (setHasModified) setHasModified(true);
    //阻止表单提交
    e.preventDefault();
  };

  const usePromotionCodeOnChange = (value) => {
    if (!value) {
      form.setFieldsValue({
        codes: [],
        promoCode: '',
        autoCombineDisabled: false,
        codeCombineDisabled: false,
      });
    }
  };

  const handleOnPrivilegeChange = (value) => {
    if (value) {
      form.setFieldsValue({
        autoCombineDisabled: false,
        codeCombineDisabled: false,
      });
    }
  };

  return (
    <Fragment>
      {isPrimary && (
        <div className={css.flexItem}>
          <Form.Item
            className={`${css.halfWidth} ${css.smallLabel}`}
            name='name'
            label={
              <Label
                title={`${getI18n('general.discountName')}*`}
                rightSubTitle={getI18n('general.forinternalreference')}
                textLength={100}
                nameKey='name'
              />
            }
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n(`general.fieldisrequired`),
                  getI18n('general.discountName'),
                ),
              },
            ]}
            labelCol={{ span: 24 }}>
            <Input maxLength={100} size='large' disabled={disableEdit} />
          </Form.Item>
          <ItemWrapper
            containerClassName={css.halfWidth}
            error={activeTimeError}
            errorClassName={css.errorClassName}
            errorText={replaceI18nVariables(
              getI18n(`general.fieldisrequired`),
              getI18n('general.activeTimePeriod'),
            )}
            title={
              <Label
                title={`${getI18n(
                  'general.activeTimePeriod',
                )} (UTC ${scTimezoneUTC})*`}
              />
            }>
            <RangePicker
              id={`time-picker-${Math.random()}`}
              size='large'
              error={{ hasError: activeTimeError, errorMsg: '' }}
              value={activeTime}
              onChange={activeTimeOnchange}
              occupiedRanges={[]}
              disabled={disableEdit}
            />
          </ItemWrapper>
        </div>
      )}
      <Form.Item
        name='description'
        label={
          <Label
            title={`${getI18n('general.descriptionofDiscount')}*`}
            rightSubTitle={getI18n('general.willdisplayonshopperend')}
            textLength={500}
            nameKey='description'
          />
        }
        rules={[
          {
            required: true,
            message: replaceI18nVariables(
              getI18n(`general.fieldisrequired`),
              getI18n('general.descriptionofDiscount'),
            ),
          },
        ]}
        labelCol={{ span: 24 }}>
        <TextArea
          size='large'
          maxLength={500}
          autoSize={{ minRows: 1, maxRows: 1 }}
          disabled={disableEdit}
        />
      </Form.Item>
      {isPrimary && (
        <Form.Item name='stackingPrivilegeEnabled' valuePropName='checked'>
          <Checkbox onChange={handleOnPrivilegeChange} disabled={disableEdit}>
            {getI18n('general.discountPrivilege')}
          </Checkbox>
        </Form.Item>
      )}

      {isPrimary && (
        <Form.Item name='usePromotionCode' valuePropName='checked'>
          <Checkbox onChange={usePromotionCodeOnChange} disabled={disableEdit}>
            {getI18n('general.needCode')}
          </Checkbox>
        </Form.Item>
      )}
      {isPrimary && (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) => {
            return prevValues.usePromotionCode !== curValues.usePromotionCode;
          }}>
          {({ getFieldValue }: any) =>
            getFieldValue('usePromotionCode') && (
              <div className={css.usePromotionCode}>
                <Form.Item
                  name='promoCode'
                  rules={[
                    {
                      pattern: /^[0-9a-zA-Z-|,｜\s｜，|,]{1,}$/,
                      message: getI18n('general.invalidformat'),
                    },
                  ]}
                  label={
                    <Label
                      title={getI18n('general.promoCode')}
                      rightSubTitle={getI18n('general.multiCode')}
                    />
                  }
                  labelCol={{ span: 24 }}>
                  <Input
                    size='large'
                    maxLength={20}
                    onChange={inputOnChange}
                    onPressEnter={pressEnter}
                    disabled={disableEdit || isVerifying}
                    {...(isVerifying
                      ? {
                          suffix: <Icon type='iconLoading1' />,
                          prefix: <Icon type='iconLoading1' />,
                          status: 'warning',
                        }
                      : {})}
                  />
                </Form.Item>
                <Form.List
                  name='codes'
                  rules={[
                    {
                      validator: async (_, codes) => {
                        if (!codes || codes.length == 0) {
                          return Promise.reject(
                            new Error(getI18n('general.oneCode')),
                          );
                        }
                      },
                    },
                  ]}>
                  {(fields, { add, move, remove }, { errors }) => (
                    <Fragment>
                      {fields.map((field, index) => (
                        <Tag
                          key={field.key}
                          closable={!disableEdit}
                          className={css.promoCode}
                          onClose={() => {
                            remove(index);
                          }}>
                          {getFieldValue('codes')[index]}
                        </Tag>
                      ))}
                      <Form.ErrorList errors={errors} />
                    </Fragment>
                  )}
                </Form.List>
                <Form.Item
                  shouldUpdate={(p, c) => {
                    const pV = get(p, 'stackingPrivilegeEnabled');
                    const cV = get(c, 'stackingPrivilegeEnabled');
                    return pV !== cV;
                  }}>
                  {(f) => {
                    const { getFieldValue } = f;
                    const pE = getFieldValue('stackingPrivilegeEnabled');
                    return (
                      <React.Fragment>
                        <Form.Item
                          name='autoCombineDisabled'
                          valuePropName='checked'>
                          <Checkbox disabled={disableEdit || pE}>
                            {getI18n('general.promoAuto')}
                          </Checkbox>
                        </Form.Item>
                        <Form.Item
                          style={{ marginBottom: 0 }}
                          name='codeCombineDisabled'
                          valuePropName='checked'>
                          <Checkbox disabled={disableEdit || pE}>
                            {getI18n('general.promoOtherPromo')}
                          </Checkbox>
                        </Form.Item>
                      </React.Fragment>
                    );
                  }}
                </Form.Item>
              </div>
            )
          }
        </Form.Item>
      )}
    </Fragment>
  );
};

export default BasicInformationComponents;
